"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var ajax = function (url, type) {
    if (type === void 0) { type = 'GET'; }
    if (!url) {
        console.error('epic-common sso.get(url) requires a url parameter!');
    }
    if (type) {
        var t = type.toUpperCase();
        if (t !== 'POST' && t !== 'GET' && t !== 'PUT' && t !== 'DELETE') {
            console.error("epic-common sso.get() invalid HTTP method type: " + type);
        }
    }
    return axios_1.default({
        method: type,
        url: url
    }).then(function (response) {
        return response ? response.data : {};
    });
};
exports.ajax = ajax;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWpheC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9hamF4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsZ0RBQTBCO0FBRTFCLElBQU0sSUFBSSxHQUFHLFVBQUMsR0FBVyxFQUFFLElBQVk7SUFBWixxQkFBQSxFQUFBLFlBQVk7SUFDbkMsSUFBSSxDQUFDLEdBQUcsRUFBRTtRQUNOLE9BQU8sQ0FBQyxLQUFLLENBQUMsb0RBQW9ELENBQUMsQ0FBQztLQUN2RTtJQUdELElBQUksSUFBSSxFQUFFO1FBQ04sSUFBTSxDQUFDLEdBQUcsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDO1FBQzdCLElBQUksQ0FBQyxLQUFLLE1BQU0sSUFBSSxDQUFDLEtBQUssS0FBSyxJQUFJLENBQUMsS0FBSyxLQUFLLElBQUksQ0FBQyxLQUFLLFFBQVEsRUFBRTtZQUM5RCxPQUFPLENBQUMsS0FBSyxDQUFDLHFEQUFtRCxJQUFNLENBQUMsQ0FBQztTQUM1RTtLQUNKO0lBRUQsT0FBTyxlQUFLLENBQUM7UUFDVCxNQUFNLEVBQUUsSUFBSTtRQUNaLEdBQUcsS0FBQTtLQUNOLENBQUMsQ0FBQyxJQUFJLENBQUMsVUFBQSxRQUFRO1FBQ1osT0FBTyxRQUFRLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQztJQUN6QyxDQUFDLENBQUMsQ0FBQztBQUNQLENBQUMsQ0FBQztBQUlNLG9CQUFJIn0=